import ct from 'countries-and-timezones';

/**
 * Browser API that returns area/location (city) for the time zone of the OS running the browser
 */
const getTimeZoneAreaLocation = (): string => {
  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  if ((timezone.includes('/') || timezone === 'UTC') && !timezone.startsWith('Etc')) {
    // only return one with area/location or UTC
    return timezone;
  } else {
    return '';
  }
};

/**
 * Return an array of all timezone in Area/Location(City) format base on IANA time zone database
 */
const getAllTimezones = (): { name: string; id: string }[] => {
  const timezones: { name: string; id: string }[] = [];

  for (const [, { name }] of Object.entries(ct.getAllTimezones())) {
    // filter entries with area/location or UTC

    if ((name.includes('/') || name === 'UTC') && !name.startsWith('Etc')) {
      timezones.push({
        id: name,
        name,
      });
    }
  }
  return timezones.sort();
};

export { getAllTimezones, getTimeZoneAreaLocation };
